import { createFileRoute, notFound } from "@tanstack/react-router";

import { HomeView } from "@/components/home/HomeView";
import { JsonLd } from "@/components/layout/JsonLd";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";
import { homeJsonLd } from "@/lib/schema";

export const Route = createFileRoute("/$locale/")({
  head: ({ params }) => {
    if (!isLocale(params.locale)) return {};
    return seoHead({
      locale: params.locale,
      path: "/",
      ...meta[params.locale].home,
      smartBanner: true,
    });
  },
  component: LocaleHomeRoute,
});

function LocaleHomeRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();

  return (
    <>
      <JsonLd data={homeJsonLd(locale)} />
      <HomeView locale={locale} />
    </>
  );
}
